import React from 'react';
import styled from '@emotion/styled';

export const Root = styled.div`
  font-family: Ubuntu;
  line-height: 1.6;
  margin: 0px auto;
  max-width: 1440px;
  padding: 0px 10px;

  .gradientBackground {
    background-image: url('/map-images/bluefade.svg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  img {
    max-width: 100%;
    height: auto;
    display: block;
  }
  .motif-motive,
  .incomplete-circles {
    display: none;
  }
  @media (min-width: 1024px) {
    padding-left: 40px;
    padding-right: 40px;
    .gradientBackgroundTeam,
    .gradientBackgroundExpertise {
      background-image: none;
    }
    .gradientBackgroundTeam {
      position: relative;
      .incomplete-circles {
        display: block;
        position: absolute;
        left: -430px;
        z-index: 1;
        top: -255px;
        width: auto;
        height: 782px;
        circle:nth-child(2) {
          display: none;
        }
      }
    }
  }
  @media (min-width: 1366px) {
    .gradientBackgroundTeam {
      .incomplete-circles {
        height: 781px;
        width: auto;
        left: -360px;
        top: -700px;
      }
    }
  }
  @media (min-width: 1920px) {
    .gradientBackgroundTeam {
      .motif-motive {
        display: block;
        width: auto;
        height: 1178px;
        position: absolute;
        right: -280px;
        top: -700px;
      }
      .incomplete-circles {
        height: 1150px;
        width: auto;
        left: -560px;
        top: -814px;
      }
    }
  }
`;

export const Section = styled.section`
  padding: 40px 16px;
  position: relative;
  margin: 0 auto;
  max-width: calc(100vw - 40px);
  img {
    margin: 48px auto 0;
    display: block;
  }
  .blueHeader.blueHeader {
    color: #0318C6;
    text-align: center;
    font-family: Syne;
    font-size: 34px;
    line-height: 40px;
  }
  .blueSubHeader {
    color: #0318C6;
    text-align: center;
    font-family: Syne;
    font-size: 18px;
    line-height: 24px;
    margin-top: 16px;
  }
  .nameAndTitle {
    color: #000;
    font-size: 15px;
    line-height: 20px;
    font-weight: 400;
    text-align: center;
    margin-top: 16px;
    p:first-of-type {
      font-weight: 700;
    }
  }
  .mobile-text {
    color: #000;
    font-family: Ubuntu;
    font-size: 15px;
    font-weight: 500;
    line-height: 25px;
    margin-top: 32px;
    .readMore {
      font-weight: 300;
      text-decoration: underline;
      color: #0318C6;
      display: inline-block;
      padding-left: 4px;
    }
    p:last-of-type {
      font-weight: 300;
      margin-top: 16px;
    }
  }
  .sectionText {
    font-weight: 500;
    line-height: 28px;
    font-size: 18px;
    font-family: Ubuntu, sans-serif;
    display: none;
    p:last-of-type {
      margin-top: 32px;
      font-weight: 300;
    }
  }
  .green-quote-icon {
    display: none;
  }
  .thing-icon {

    display: block;
    margin: 16px auto 0;
  }
  .thing-two-icon,
  .thing-three-icon {
    display: none;
  }

  @media (min-width: 1024px) {
    &.hidden-before-scroll {
      opacity: 0;
      transform: translateY(40px);
      transition: all 0.3s ease-out;
    }
    &.fade-in-up {
      opacity: 1;
      transform: translateY(0);
      transition: all 0.3s ease-out;
    }
    .mobile-text {
      display: none;
    }
    .blueHeader.blueHeader {
      font-size: 75px;
      line-height: 65px;
    }
    .blueSubHeader {
      font-size: 28px;
      line-height: 36px;
    }
    .sectionText {
      display: block;
      /* margin-top: 32px; */
    }
    .thing-icon {
      display: none;
    }
    .thing-two-icon {
      display: block;
      margin: 72px auto 0;
    }
    .green-quote-icon {
      display: block;
      margin: 16px auto 0;
    }
  }
  @media (min-width: 1920px) {
    .nameAndTitle {
      font-size: 18px;
      margin-top: 20px;
    }
    .sectionText {
      font-size: 18px;
      line-height: 28px;
    }
    .thing-two-icon {
      display: none;
    }
    .thing-three-icon {
      display: block;
      margin: 72px auto 0;
    }
  }
`;

export const MissionSection = styled(Section)` 
  position: relative;
  z-index: 4;
  * {
    position: relative;
    z-index: 4;
  }
  .mobile-circles {
    position: absolute;
    top: 0;
    right: -20px;
    z-index: 1;
  }
  .huge-rings-two,
  .huge-rings {
    display: none;
  }
  @media (min-width: 1024px) {
    padding-top: 128px;
    .flexer {
      display: flex;
      flex-direction: row-reverse;
      justify-content: space-between;
      margin: 56px auto 0;
      max-width: 1024px;
      padding: 0 60px;
      
      img {
        height: auto;
        margin: 0;
        max-width: 380px;
        width: 100%;
      }
    }
    .green-quote-icon {
      display: block;
      width: 120px;
      height: auto;
      margin: 36px auto -20px;
    }
    .blueSubHeader {
      max-width: 542px;
      margin: 16px auto 0;
    }
    .sectionText {
      max-width: 405px;
      font-size: 16px;
      line-height: 26px;
    }
    .mobile-circles {
      display: none;
    }
    .huge-rings {
      display: block;
      position: absolute;
      bottom: 0;
      right: -176px;
      z-index: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      height: 780px;
      width: auto;
    }
  }
  @media (min-width: 1366px) {
    .huge-rings {
      right: -102px;
    }
  }
  @media (min-width: 1920px) {
    padding-top: 194px;
    .blueHeader.blueHeader {
      font-size: 84px;
      line-height: 0.75em;
    }
    .blueSubHeader {
      font-size: 33px;
      line-height: 40px;
      max-width: 727px;
    }
    .nameAndTitle {
      font-size: 18px;
    }
    .sectionText {
      font-size: 18px;
      line-height: 28px;
      max-width: 424px;
    }
    .huge-rings {
      display: none;
    }
    .huge-rings-two {
      display: block;
      position: absolute;
      right: -280px;
      bottom: -180px;
    }
    .thing-two-icon {
      display: none;
    }
    .thing-three-icon {
      display: block;
      margin: 70px auto 0;
    }

    .flexer {
      margin-top: 64px;
      .founder-image {
        max-width: 418px;
      }
    }
  }
`;
export const HildeshaimSection = styled(Section)` 
  @media (min-width: 1024px) {
    margin-bottom: -112px;
    .flexer { 
      align-items: flex-end;
      display: flex;
      justify-content: center;
      gap: 20px;
      margin: 56px auto 0;
      max-width: 1024px;
      padding: 0 20px;
      .client-image {
        margin: 0;
        max-width: 440px;
        width: 100%;
        height: auto;
      }
      .sectionText {
        max-width: 405px;
        font-size: 16px;
        line-height: 26px;
      }
    }
    .blueSubHeader {
      max-width: 541px;
      margin: 16px auto 0;
    }
    .green-quote-icon {
      margin: 8px auto -20px;
    }
    .thing-two-icon {
      margin-top: 80px;
    }
  }
  @media (min-width: 1366px) {
    .flexer{
      align-items: center;
      gap: 24px;
      .sectionText {
        max-width: 382px;
      }
    }
  }
  @media (min-width: 1920px) {
    margin-bottom: 0px;
    .blueSubHeader {
      max-width: 780px;
      font-size: 33px;
      line-height: 40px;
      margin-top: 8px;
    }
    .flexer {
      margin-top: 60px;
      max-width: 100%;
      gap: 32px;
      .sectionText {
        max-width: 422px;
      }
      .client-image {
        max-width: 482px;
      }
    }
    .thing-three-icon {
      margin-top: 0px;
      position: relative;
      bottom: -120px;
    }
  }
`;

export const ExpertiseSection = styled(Section)`
  padding-top: 32px;
  .expertise-motif,
  .thing-four-icon {
    display: none;
  }
  .three-plus {
    position: absolute;
    left: -21px;
    top: -50px;
  }
  @media (min-width: 1024px) {
    padding-left: 30px;
    padding-right: 30px;
    /* max-width: 1024px; */
    background-image: url('/map-images/bluefade2.svg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    h2 {
      position: relative;
      z-index: 12;
      margin-top: 120px;
    }
    .flexer {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin: 56px auto 0;
      max-width: 830px;
      padding: 0 20px;
      position: relative;
      z-index: 12;
      img {
        height: auto;
        margin: 0;
        max-width: 372px;
        width: 100%;
        margin-right: 20px;
      }
      .green-quote-icon {
        margin: 0;
        margin-left: -28px;
        margin-top: -28px;
      }
      .sectionOne {
        width: 350px;
        .blueSubHeader {
          text-align: left;
        }
      }
      .sectionText {
        width: 100%;
        font-size: 16px;
        line-height: 26px;
        display: flex;
        margin-top: 12px;
        justify-content: space-between;
        p {
          max-width: 405px;
          :last-of-type {
            margin-top: 0;
          }
        }
      }
    }
    .nameAndTitle {
      text-align: left;
    }
    .blueSubHeader {
      max-width: 541px;
      margin: 16px auto 0;
    }
    .green-quote-icon {
      margin: 8px auto -20px;
    }
    .thing-two-icon {
      margin-top: 80px;
    }
    .three-plus {
      display: none;
    }
    .expertise-motif,
    .thing-four-icon {
      display: block;
      position: absolute;
      left: -80px;
      z-index: 10;
    }
    .thing-four-icon{
      width: 178px;
      height: auto;
      top: -43px;
      left: -47px;
    }
    .expertise-motif {
      width: 426px;
      height: auto;
      left: -48px;
    }
  }
  @media (min-width: 1366px) {
    max-width: 1004px;
    margin: 0 auto;
    .flexer {
      padding-left: 0;
      padding-right: 0;
      .sectionText {
        p {
          max-width: 388px;
        }
      }
    }
    .expertise-motif {
      left: -130px;
      bottom: 292px;
    }
  }
  @media (min-width: 1920px) {
    max-width: 1340px;
    .blueHeader.blueHeader {
      font-size: 84px;
      line-height: 80px;
    }
    .blueSubHeader {
      font-size: 33px;
      line-height: 40px;
      max-width: 325px;
      margin: 0;
    }
    .flexer {
      max-width: 885px;
      margin-top: 32px;
      img {
        max-width: 407px;
        margin-right: 50px;
        margin-top: 40px;
      }
      .green-quote-icon {
        margin-bottom: -17px;
      }
      .sectionText {
        font-size: 18px;
        line-height: 28px;
        margin-top: 32px;
        p {
          max-width: 424px;
        }
      }
    }
    .expertise-motif {
      width: 568px;
      left: -48px;
      bottom: 344px;
    }
    .thing-four-icon {
      width: 231px;
      left: -154px;
      top: -86px;
      z-index: 11;
    }
    .thing-three-icon {
      margin-top: 102px;
    }
  }
`;
export const TechnologySection = styled(Section)` 
  @media (min-width: 1024px) {
    position: relative;
    z-index: 10;
    .flexer {
      display: flex;
      align-items: flex-end;
      justify-content: center;
      max-width: 835px;
      margin: 0px auto;
    }
    .green-quote-icon {
      margin: 32px 0 -30px -30px;
    }
    // this is the image ¯\_(ツ)_/¯
    .sectionTwo {
      max-width: 400px;
      width: 100%;
      height: auto;
      margin: 0;
      margin-left: -20px;
    }
    .blueSubHeader {
      text-align: left;
      font-size: 28px;
      line-height: 36px;
      max-width: 235px;
    }
    .nameAndTitle {
      text-align: left;
    }
    .sectionText {
      max-width: 230px;
      p {
        font-size: 16px;
      }
    }
    .thing-two-icon {
      margin-bottom: -100px;
    }
  }
  @media (min-width: 1366px) {
    .flexer {
      max-width: 960px;
    }
    .sectionOne {
      margin-bottom: 48px;
    }
    .sectionText {
      max-width: 281px;
      margin-bottom: 72px;
    }
  }
  @media (min-width: 1920px) {
    .flexer {
      max-width: 1125px;
    }
    .blueSubHeader {
      max-width: 356px;
      font-size: 33px;
      line-height: 40px;
    }
    .sectionOne {
      margin-bottom: 8px;
    }
    .sectionTwo {
      max-width: 440px;
      margin-left: 0px;
    }
    .sectionText {
      max-width: 296px;
      font-size: 18px;
      line-height: 28px;
      margin-bottom: 4px;
    }
    .thing-three-icon {
      margin-top: 100px;
    }
  }
`;
export const TeamSection = styled(Section)`
  padding-top: 32px;
  .five-plus {
    position: absolute;
    right: -0px;
    top: -50px;
  }


  @media (min-width: 1024px) {
    padding-top: 159px;
    background-image: url('/map-images/bluefade3.svg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    max-width: 942px;
     *:not(.incomplete-circles) {
      position: relative;
      z-index: 15;
    }
    .five-plus {
      right: 6px;
      top: 18px;
      position: absolute;
      width: 192px;
      height: auto;
    }
    .green-quote-icon {
      margin-top: 32px;
      margin-bottom: -12px;
    }
    .blueSubHeader {
      font-size: 28px;
      line-height: 36px;
      max-width: 541px;
      margin: 0px auto;
    }
    .team-image {
      width: 100%;
      max-width: 726px;
      height: auto;
      margin: 56px auto 0;
    }
    .sectionText {
      max-width: 618px;
      font-size: 16px;
      line-height: 26px;
      margin: 56px auto 0;
      text-align: center;
    }
  }
  @media (min-width: 1366px) {
    max-width: 1004px;
    .five-plus {
      right: -80px;
      top: 24px;
    }
    .sectionText {
      max-width: 789px;
      margin-top: 58px;
    }
  }
  @media (min-width: 1920px) {
    max-width: 1340px;
    margin-top: -100px;
    .five-plus {
      width: 231px;
      right: 0px;
      top: 0;
    }
    .blueHeader.blueHeader {
      font-size: 84px;
      line-height: 80px;
    }
    .green-quote-icon {
      margin-top: 0;
    }
    .blueSubHeader {
      max-width: 926px;
      width: 100%;
      font-size: 33px;
      line-height: 40px;
      margin: 0 auto;
    }
    .sectionText {
      font-size: 18px;
      line-height: 28px;
      max-width: 880px;
    }
    .team-image {
      margin-top: 20px;
    }
    .thing-three-icon {
      margin-top: 100px;
    }
  }
`;
export const RelationshipsSection = styled(Section)`
  overflow: visible;
  padding-top: 40px;
  .single-one,
  .single-two,
  .single-three {
    display: none;
  }
  * {
    position: relative;
    z-index: 2;
  }
  .targetsites {
    position: absolute;
    left: -22px;
    width: calc(100% + 44px);
    top: 10px;
    z-index: 1;
  }
  .complete_circles {
    display: none;
  }
  @media (min-width: 1024px) {
    padding-top: 0;
    margin-top: -76px;
    h2 {
      position: relative;
      z-index: 12;
      margin-top: 120px;
    }
    .targetsites {
      display: none;
    }
    .complete_circles {
      display: block;
      width: 782px;
      height: 782px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: -132px;
      z-index: 1;
    }
    .flexer {
      align-items: flex-start;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin: 56px auto 0;
      max-width: 830px;
      padding: 0px;
      position: relative;
      z-index: 12;
      img {
        height: auto;
        margin: 0;
        max-width: 377px;
        width: 100%;
        margin-right: 5px;
      }
      .green-quote-icon {
        margin: 0;
        margin-left: -28px;
        margin-top: -28px;
      }
      .sectionOne {
        width: 365px;
        .blueSubHeader {
          text-align: left;
        }
      }
      .sectionText {
        display: flex;
        font-size: 16px;
        justify-content: space-between;
        line-height: 26px;
        margin-top: 34px;
        width: 100%;
        p {
          max-width: 405px;
          :last-of-type {
            margin-top: 0;
          }
        }
      }
    }
    .nameAndTitle {
      text-align: left;
    }
    .blueSubHeader {
      max-width: 370px;
      margin: 0px auto;
    }
    .green-quote-icon {
      margin: 8px auto -20px;
    }
    .thing-two-icon {
      margin-top: 80px;
    }
    .three-plus {
      display: none;
    }
    .expertise-motif,
    .thing-four-icon {
      display: block;
      position: absolute;
      left: -80px;
      z-index: 10;
    }
    .thing-four-icon{
      width: 178px;
      height: auto;
      top: -43px;
      left: -47px;
    }
    .expertise-motif {
      width: 426px;
      height: auto;
      left: -48px;
    }
    .single-one,
    .single-two,
    .single-three {
      display: block;
      position: absolute;
      bottom: -70px;
      left: 40px;
    }
    .single-two {
      bottom: -110px;
      left: 90px;
    }
    .single-three {
      right: 150px;
      bottom: -90px;
      left: unset
    }
  }
  @media (min-width: 1366px) {
    max-width: 1004px;
    margin: 0 auto;
    .flexer {
      .sectionText {
        p {
          max-width: 388px;
        }
      }
    }
    .expertise-motif {
      left: -130px;
      bottom: 292px;
    }
  }
  @media (min-width: 1920px) {
    max-width: 1340px;
    margin-top: -90px;
    .complete_circles {
      width: 1150px;
      height: 1150px;
      top: -110px;
    }
    .blueHeader.blueHeader {
      font-size: 84px;
      line-height: 80px;
    }
    .blueSubHeader {
      font-size: 33px;
      line-height: 40px;
      max-width: 100%;
      margin: 0;
    }
    .flexer {
      max-width: 885px;
      margin-top: 20px;
      img {
        max-width: 412px;
        margin-right: 0px;
        margin-top: 10px;
      }
      .green-quote-icon {
        margin-bottom: -17px;
      }
      .sectionOne {
        width: 422px;
      }
      .sectionText {
        font-size: 18px;
        line-height: 28px;
        margin-top: 24px;
        p {
          max-width: 424px;
        }
      }
    }
    .expertise-motif {
      width: 568px;
      left: -48px;
      bottom: 344px;
    }
    .thing-four-icon {
      width: 231px;
      left: -154px;
      top: -86px;
      z-index: 11;
    }
    .thing-three-icon {
      margin-top: 102px;
    }
    .single-one,
    .single-two,
    .single-three {
      width: 66px;
      height: 66px;
    }
    .single-one {
      left: -150px;
      bottom: -161px;
    }
    .single-two {
      bottom: -232px;
      left: -90px;
    }
    .single-three {
      bottom: -224px;
      right: 250px;
    }
  }
`;
export const CPASection = styled(Section)`
  h2 {
    position: relative;
    display: inline-flex;
  }
  .single-one {
    position: absolute;
    left: -100px;
    top: -40px;
    z-index: 4;
  }
  .single-two {
    position: absolute;
    left: -140px;
    top: -8px;
    z-index: 4;
  }
  .single-three {
    position: absolute;
    right: -130px;
    top: 8px;
    z-index: 4;
  }
  
  @media (min-width: 1024px) {
    .single-one,
    .single-two,
    .single-three {
      display: none;
    }
    z-index: 10;
    h2 {
      margin-top: 0px;
      font-size: 75px;
      line-height: 65px;
    }
    .thing-two-icon {
      z-index: 12;
      position: relative
    }
    .flexer {
      align-items: center;
      display: flex;
      flex-wrap: wrap;
      gap: 26px;
      justify-content: flex-start;
      margin: 0px auto;
      max-width: 850px;
      .sectionOne {
        align-items: flex-start;
        order: 2;
        text-align: left;
        width: 370px;
        .green-quote-icon {
          margin-left: -29px;
        }
        .blueSubHeader {
          font-size: 28px;
          line-height: 36px;
          margin-bottom: 12px;
          margin-top: -8px;
          text-align: left;
        }
        .nameAndTitle {
          text-align: left;
        }
      }
      .sectionTwo {
        height: auto;
        margin-left: 0;
        margin-right: 0;
        max-width: 444px;
        order: 1;
        width: 100%;
      }
      .sectionText {
        order: 3;
        max-width: 618px;
        margin: 34px auto 0;
        p {
          font-size: 16px;
          text-align: center;
          line-height: 26px;
          :last-of-type {
            margin-top: 0px;
          }
        }
      }
    }
  }
  @media (min-width: 1366px) {
    padding-top: 60px;
    .flexer {
      .sectionText {
        max-width: 592px;
      }
    }
  }
  @media (min-width: 1920px) {
    padding-top: 42px;
    position: relative;
    z-index: 15;
    .blueHeader.blueHeader {
      font-size: 84px;
      line-height: 80px;
    }
    .flexer {
      max-width: 960px;
      gap: 28px;
      align-items: flex-start;
      .sectionTwo {
        max-width: 486px;
        margin-top: 10px;
      }
      .sectionOne {
        max-width: 422px;
        width: 100%;
        .blueSubHeader {
          font-size: 33px;
          line-height: 40px;
        }
      }
      .sectionText {
        font-size: 18px;
        line-height: 28px;
        margin-top: 8px;
        max-width: 602px;
      }
      .thing-three-icon {
        margin-top: 102px;
      }
      .green-quote-icon {
        margin-top: -16px;
      }
    }
  }
`;

export const OuterCLientsSection = styled.div`
  @media (min-width: 1024px) {
    background-color: #F6F6F6;
    box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.05);
    margin: -120px auto -126px;
    max-width: 942px;
    position: relative;
    width: 100%;
    z-index: 5;
  }
  @media (min-width: 1366px) {
    max-width: 1004px;
  }
  @media (min-width: 1920px) {
    margin-top: -96px;
    max-width: 1338px;
  }
`;

export const OurClientsSection = styled(Section)`
  /* overflow: hidden; */
  margin: 0 auto;
  .darth-fader {
    height: auto;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
  .sectionText {
    display: block;
    font-size: 15px;
    font-weight: 300;
    line-height: 25px;
    margin-top: 48px;
    text-align: center;
  }
  .three-plus {
    position: absolute;
    right: 10px;
    top: -50px;
    z-index: 4;
  }
  .single-one {
    bottom: 86px;
    left: -36px;
    position: absolute;
    z-index: 4;
  }
  .single-two {
    bottom: 48px;
    left: -10px;
    position: absolute;
    z-index: 4;
  }
  .single-three {
    bottom: 30px;
    position: absolute;
    right: 0px;
    z-index: 4;
  }
  .sectionText {
    display: block;
  }
  .andYetAnotherThreePlusGroup,
  .doubleTrouble,
  .threeVertical {
    display: none;
  }
  @media (min-width: 1024px) {
    background-image: url('/map-images/client-fade-tablet.svg');
    background-position: center;
    background-repeat: no-repeat; 
    background-size: cover;
    height: 780px;
    padding: 159px 96px 78px;
    position: relative;
    width: 100%;
    .darth-fader {
      display: none;
    }
    .blueSubHeader {
      max-width: 707px;
      margin-top: -16px;
      br { display: none;}
    }
    .sectionText {
      max-width: 618px;
      margin: 56px auto 0;
      p {
        font-size: 16px;
        line-height: 26px;
        :last-of-type {
          margin-top: 0;
        }
      }
    }
    .thing-two-icon,
    .single-three-icon,
    .single-one,
    .single-two,
    .three-plus,
    .single-three {
      display: none;
    }
    .andYetAnotherThreePlusGroup {
      display: block;
      position: absolute;
      right: 32px;
      top: 45px;
    }
    .threeVertical {
      bottom: 0px;
      display: block;
      left: 40px;
      position: absolute;
    }
    .doubleTrouble {
      bottom: 5px;
      display: block;
      position: absolute;
      right: 34px;
    }
  }
  @media (min-width: 1366px) {
    padding-top: 178px;
    .blueSubHeader {
      max-width: 745px;
    }
  }
  @media (min-width: 1920px) {
    background-image: url('/map-images/clients-fade.svg');
    height: 846px;
    padding-top: 122px;
    .blueHeader.blueHeader {
      font-size: 84px;
      line-height: 80px;
    }
    .blueSubHeader {
      font-size: 33px;
      line-height: 40px;
      margin: 0 auto;
      max-width: 878px;
      br {
        display: block;
      }
    }
    .andYetAnotherThreePlusGroup {
      height: auto;
      right: 0px;
      top: 120px;
      width: 190px;
    }
    .threeVertical {
      height: auto;
      width: 130px;
    }
    .doubleTrouble { 
      height: auto;
      width: 120px;
    }
    .sectionText {
      margin-top: 60px;
      max-width: 690px;
      p {
        font-size: 18px;
        line-height: 28px;
        margin-top: 0;
        max-width: 690px;
      }
    }
  }
`;

export const lastSection = {
  '@media (min-width: 1024px)': {
    paddingTop: '180px',
    height: '377px',
  },
  '@media (min-width: 1366px)': {
    paddingTop: '225px',
    height: '420px',
  },
  '@media (min-width: 1920px)': {
    paddingTop: '225px',
    height: '600px',
  },
};

export const motifator = {
  '@media (min-width: 1024px)': {
    top: '24px',
  },
  '@media (min-width: 1366px)': {
    width: '314px',
    maxWidth: '314px',
  },
  '@media (min-width: 1920px)': {
    width: '600px',
    maxWidth: '600px',
    height: '732px',
    top: 'unset',
    bottom: '-16px',
  },
};
